import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { windowInputOf } from 'shared/metrics-window'
import { trpc } from '@/main'

// Pathless layout that OWNS the overview's window-keyed reads, so a range switch re-keys THIS match and not the screen
// above it, which would repaint its skeleton. No component; the screen reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/admin/metrics/_overview/_window')({
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  context: ({ deps }) => {
    const window = windowInputOf(deps)
    return {
      metricsKpisQueryOptions: trpc.admin.metricsKpis.queryOptions(window),
      metricsTrafficQueryOptions: trpc.admin.metricsTraffic.queryOptions(window),
      metricsEndpointsQueryOptions: trpc.admin.metricsEndpoints.queryOptions(window),
      metricsErrorsQueryOptions: trpc.admin.metricsErrors.queryOptions(window),
    }
  },
  loader: ({ context }) => {
    context.queryClient.query(context.metricsKpisQueryOptions).catch(noop)
    context.queryClient.query(context.metricsTrafficQueryOptions).catch(noop)
    context.queryClient.query(context.metricsEndpointsQueryOptions).catch(noop)
    context.queryClient.query(context.metricsErrorsQueryOptions).catch(noop)
  },
})
